"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedPropertyString = void 0;
const functions_1 = require("./functions");
const WrappedPropertyBase_1 = require("./WrappedPropertyBase");
const WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
const defineSchema_1 = require("../JSchema/defineSchema");
const fixDateFormat_1 = require("../JSchema/fixDateFormat");
const getRuleMessage_1 = require("../JSchema/getRuleMessage");
const capitalize_1 = require("../methods/capitalize");
const fdatetime_1 = require("../methods/fdatetime");
const lang_1 = require("../methods/lang");
const schemaMethods_1 = require("../schemaMethods");
/**
 * obiekt reprezentujący pole tkestowe
 *
 * @export
 * @class WrappedPropertyString
 * @extends {WrappedPropertyBase<IInternal>}
 * @implements {IWrappedProperty}
 */
class WrappedPropertyString extends WrappedPropertyBase_1.WrappedPropertyBase {
    constructor(props) {
        super(props);
        (0, functions_1.wrapSchemaProps)(this, this._internal, 'number', [
            'maxLength',
            'minLength',
            'minimum',
            'maximum',
            'exclusiveMaximum',
            'exclusiveMinimum'
        ]);
        if (props.schema.pattern) {
            if (typeof props.schema.pattern == 'string') {
                const cpattern = props.options.schemaMethods.patterns[props.schema.pattern];
                if (cpattern) {
                    this.$schema.pattern = cpattern;
                }
                else {
                    try {
                        this.$schema.pattern = new RegExp(props.schema.pattern, props.schema.patternFlags === null ? '' : props.schema.patternFlags || 'i');
                    }
                    catch (err) {
                        (0, functions_1.logError)(this, 'pattern regex', err, props.schema.pattern);
                    }
                }
            }
            else if ((0, defineSchema_1.isFunction)(props.schema.pattern) || Array.isArray(props.schema.pattern)) {
                (0, functions_1.wrapSchemaProp)(this, 'pattern', this._internal);
            }
            else if (props.schema.pattern instanceof RegExp) {
                this.$schema.pattern = props.schema.pattern;
            }
        }
        if (this.$schema.warnings) {
            (0, functions_1.wrapWarningProps)(this, this._internal, 'number', [
                'maxLength',
                'minLength',
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum'
            ]);
        }
        // initVue(this, this._internal);
        // console.log('string created', propName, this._internal.vmUserData);
    }
    /**
     * pobranie formatu pola, `format` w schema lub w 'warnings'
     *
     * @readonly
     * @type {string}
     * @memberof WrappedPropertyString
     */
    get $format() {
        return this.$schema.format || (this.$schema.warnings && this.$schema.warnings.format) || '';
    }
    /**
     * sprawdza pole pod kątem błedó
     *
     * @param {*} [value] wartość
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} wynik
     * @memberof WrappedPropertyString
     */
    $validate(value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (value === '' || value === null) {
            if (this.$schema.fieldRequired) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message,
                    expected: true
                };
                return message;
            }
            if (this.$schema.enum && this.$schema.enum.indexOf(value) === -1) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'enum', value, this.$schema);
                this.$validateResult = {
                    validation: 'enum',
                    message,
                    expected: this.$schema.enum
                };
                return message;
            }
            return null;
        }
        return super.$validate(value);
    }
    /**
     * sprawdza pole pod kątem ostrzeżeń
     *
     * @param {*} [value] wartośc pola
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyString
     */
    $check(value, skipDirty, checkResult) {
        if (this.$schema.warnings && !this.$disabled) {
            if (value === undefined) {
                value = this.$model;
            }
            if (!skipDirty) {
                this.$dirty = true;
            }
            checkResult = checkResult || [];
            this.$checkResult = [];
            const req = this.$schema.warnings.fieldRequired;
            // console.log('propName.get()', req, svalue);
            if (value === '' || value === null) {
                if (req) {
                    // console.timeEnd('(string)$validate');
                    const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'required', value, this.$schema);
                    this.$checkResult.push({
                        validation: 'required',
                        message,
                        expected: true
                    });
                    checkResult.push(message);
                }
                if (this.$schema.warnings.enum && this.$schema.warnings.enum.indexOf(value) === -1) {
                    const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'enum', value, this.$schema);
                    this.$checkResult.push({
                        validation: 'enum',
                        message,
                        expected: this.$schema.warnings.enum
                    });
                    checkResult.push(message);
                }
                return checkResult;
            }
            // console.timeEnd('(string)$validate');
            return super.$check(value, skipDirty, checkResult);
        }
        return (this.$checkResult = []);
    }
    /**
     * naprawia format daty
     *
     * @returns {number}
     * @memberof WrappedPropertyString
     */
    $fixDateFormat() {
        switch (this.$format) {
            case 'date':
                // this._internal.parent, this.$key, value
                return (0, fixDateFormat_1.fixDateField)(this._internal.parent, this.$key) ? 1 : 0;
            case 'date-time':
                return (0, fixDateFormat_1.fixDateTimeField)(this._internal.parent, this.$key) ? 1 : 0;
        }
        return 0;
    }
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyString
     */
    getValue(svalue) {
        var _a, _b, _c, _d;
        if (svalue === undefined)
            svalue = this.$model;
        if (svalue !== null) {
            switch (this.$format) {
                case 'date':
                    if (svalue && svalue.length >= 10) {
                        // var lang = this._options._lang ?? this._options.schemaMethods.lang.current;
                        const lang = (_b = (_a = this._options._lang) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : lang_1.defaultLang.current;
                        svalue = lang.shortDateFormatter(svalue);
                    }
                    break;
                case 'date-time':
                    if (svalue && svalue.length >= 10) {
                        // var lang = this._options._lang ?? this._options.schemaMethods.lang.current;
                        const lang = (_d = (_c = this._options._lang) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : lang_1.defaultLang.current;
                        if (this._options.utc) {
                            const dt = svalue.indexOf('Z') == -1 ? new Date(svalue + 'Z') : new Date(svalue);
                            svalue = (0, schemaMethods_1.fdatetime)(dt);
                        }
                        let nsvalue = lang.shortDateFormatter(svalue);
                        if (svalue.length === 19) {
                            const ntvalue = svalue.substring(11, 19);
                            // if (ntvalue !== '00:00:00') {
                            nsvalue += ' ' + ntvalue;
                            // }
                        }
                        // console.log('get date-time', svalue, nsvalue, ntvalue);
                        svalue = nsvalue;
                    }
                    break;
            }
        }
        return svalue || '';
    }
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @returns
     * @memberof WrappedPropertyString
     */
    setValue(newValue) {
        var _a, _b, _c, _d, _e, _f;
        if (this.$disabled) {
            return;
        }
        this._options._userInput = true;
        // check save type
        if (newValue !== null) {
            if (newValue === true)
                newValue = 'true';
            else if (newValue === false)
                newValue = '';
            if (newValue) {
                switch (this.$format) {
                    case 'uppercase':
                        newValue = newValue.toLocaleUpperCase();
                        break;
                    case 'lowercase':
                        newValue = newValue.toLocaleLowerCase();
                        break;
                    case 'capitalize':
                        newValue = (0, capitalize_1.capitalize)(newValue);
                        break;
                    case 'date':
                        if (newValue.length >= 8) {
                            // var lang = this._options._lang ?? this._options.schemaMethods.lang.current;
                            const lang = (_b = (_a = this._options._lang) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : lang_1.defaultLang.current;
                            const newValue2 = lang.shortDateReformatter(newValue);
                            if (newValue2) {
                                newValue = newValue2;
                            }
                        }
                        /*
                        if (newValue.length >= 10 && newValue[2] == '.' && newValue[5] == '.') {
                          newValue = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`;
                        }
                        */
                        break;
                    case 'date-time':
                        if (newValue.length >= 8) {
                            // var lang = this._options._lang ?? this._options.schemaMethods.lang.current;
                            const lang = (_d = (_c = this._options._lang) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : lang_1.defaultLang.current;
                            let newValue2 = lang.shortDateReformatter(newValue);
                            const sppos = newValue.indexOf(' ');
                            if (sppos > -1) {
                                const hvalue = newValue.substring(sppos).trim();
                                if (hvalue)
                                    newValue2 += ' ' + hvalue;
                            }
                            if (newValue2) {
                                if (this._options.utc) {
                                    const dt = new Date(newValue2);
                                    newValue2 = (0, fdatetime_1.fdatetimeUTCZ)(dt);
                                }
                                newValue = newValue2;
                            }
                        }
                        /*
                        if (newValue.length >= 10 && newValue[2] == '.' && newValue[5] == '.') {
                          if (newValue.length === 19) {
                            newValue = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(
                              0,
                              2
                            )} ${newValue.substring(11)}`;
                          } else {
                            newValue = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)} 00:00:00`;
                          }
                        }
                        */
                        break;
                }
            }
        }
        if ((_e = this._options._anyEvent) === null || _e === void 0 ? void 0 : _e.beforeChange) {
            const prevValue = this.$model;
            const event = { type: 'beforeChange', target: this, value: newValue, prevValue };
            if ((0, functions_1.runEvent)(event)) {
                if (event.value !== newValue) {
                    newValue = event.value;
                }
            }
        }
        if ((_f = this._options._anyEvent) === null || _f === void 0 ? void 0 : _f.change) {
            const prevValue = this.$model;
            this.$model = newValue;
            if (newValue != prevValue) {
                (0, functions_1.runEvent)({ type: 'change', target: this, value: newValue, prevValue });
            }
        }
        else {
            this.$model = newValue;
        }
        // this.$model = newValue;
        if (!this.$dirty && this._options.dirtyOnInput) {
            this.$dirty = true;
        }
    }
}
exports.WrappedPropertyString = WrappedPropertyString;
WrappedPropertyCtor_1.WrappedPropertyCtor.string = WrappedPropertyString;
exports.default = WrappedPropertyString;
//# sourceMappingURL=WrappedPropertyString.js.map